<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-input
        class="searchInput"
        size="small"
        placeholder="考试名称"
        v-model="searchCondition.testName"
        clearable
      >
      </el-input
      >&emsp;
      <el-input
        class="searchInput"
        width="20px"
        v-model="searchCondition.paperName"
        placeholder="论文名称"
        size="small"
        clearable
      >
      </el-input
      >&emsp;
      <el-select
        width="20px"
        v-model="searchCondition.reviewStatus"
        placeholder="审核状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in reviewOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option> </el-select
      >&emsp;
      <el-input
        class="searchInput"
        size="small"
        placeholder="考生姓名"
        v-model="searchCondition.userName"
        clearable
      >
      </el-input
      >&emsp;
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getPaperInterviewList()"
        >查询
      </el-button>
      <el-button
        type="info"
        size="small"
        icon="el-icon-refresh-right"
        @click="Object.assign(searchCondition, $options.data().searchCondition)"
        >重置
      </el-button>
    </div>

    <div class="tableContainer">
      <div class="actionBar">
        <el-button @click="exportData" plain> 导出 </el-button>&emsp;
        <el-button @click="dialogVisibleImport = true" plain> 导入 </el-button
        >&emsp;
        <el-button
          class="setScoreBar bluBar"
          size="small"
          @click="setScore = true"
          >设置及格分数
        </el-button>
      </div>
      <Table :columns="columns" :data="paperInterviewList" border>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <el-button
              plain
              class="bluBar"
              @click="goToDetail('paperInterviewDetail', row)"
              >详情
            </el-button>
            <el-button class="bluBar" @click="isMark = true"> 评分 </el-button>
          </div>
        </template>
      </Table>

      <el-dialog
        title="评分"
        :visible.sync="isMark"
        append-to-body
        :label-width="formLabelWidth"
        @close="Object.assign(markData, $options.data().markData)"
      >
        <el-form :model="markData">
          <el-form-item label="分数">
            <el-input
              v-model.trim="markData.score"
              autocomplete="off"
              type="number"
              onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)"
            ></el-input>
          </el-form-item>
          <el-form-item label="评分人">
            <el-input
              v-model="markData.auditTeacher"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isMark = false">取 消</el-button>
          <el-button type="primary" @click="isMark = false">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="设置及格分数"
        :visible.sync="setScore"
        append-to-body
        :label-width="formLabelWidth"
        @close="Object.assign(setScoreData, $options.data().setScoreData)"
      >
        <el-form :model="setScoreData">
          <el-form-item label="报名来源 :">
            <el-radio-group
              v-model="setScoreData.source"
              @change="clearTestId()"
            >
              <el-radio :label="0">专业报名</el-radio>
              <el-radio :label="1">简易报名</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考试名称 :">
            <el-select
              v-model="setScoreData.testId"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in paperApplyListComputed"
                :key="item.testName"
                :label="item.testName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="及格分数">
            <el-input
              v-model="setScoreData.score"
              autocomplete="off"
              type="number"
              onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
            ></el-input>
          </el-form-item>
        </el-form>
        <div
          slot=" footer
            "
          class="dialog-footer"
        >
          <el-button @click="setScore = false">取 消</el-button>
          <el-button type="primary" @click="setPassScore()">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisibleImport"
        width="40%"
        append-to-body
        @closed="reset()"
      >
        <el-form>
          <el-form-item label="模板说明">
            <el-tag type="info"
              >excel模版说明:批量更新审核状态，需按照此模板填写，不要改变原始样式</el-tag
            >
          </el-form-item>
          <el-form-item label="模板下载">
            <el-tag>
              <i class="el-icon-download" />
              <!-- 这里的话可以把这个模板放到阿里的OSS中 这个地方是采用放入项目中-->
              <a :href="downloadUrl" icon="md-album">点击下载模板</a>
            </el-tag>
          </el-form-item>
          <el-form-item label="上传文件">
            <el-upload
              ref="upload"
              :auto-upload="false"
              :on-change="fileChange"
              :on-exceed="exceedFile"
              :on-success="handleSuccess"
              :on-error="handleError"
              :http-request="uploadPaper"
              :headers="{ Authorization: getStore('accessToken') }"
              :limit="1"
              action="/bpi/paper-setting/v1/excel/excelImport"
              name="file"
              accept=".xls,.xlsx"
              :file-list="fileList"
            >
              <el-button size="small" plain>选择文件</el-button>
              &emsp;!只能上传xls/xlsx文件
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="importData()">确 定</el-button>
        </span>
      </el-dialog>

      <!--分页-->

      <el-row>
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginations.page_index"
              :page-sizes="paginations.page_sizes"
              :page-size.sync="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getPaperApplyList,
  getPaperInterviewList,
  paperReviewExcelExport,
  setPassScore,
  importPaperInterviewList,
  exportPaperInterviewList,
  paperReviewExcelImport,
} from "@/api/paper.js";

export default {
  data() {
    return {
      fileList: [],
      downloadUrl: "../面试导入模板.xlsx",
      dialogVisibleImport: false,
      formLabelWidth: "50px",
      isMark: false,
      setScore: false,
      markData: {
        score: "",
        auditTeacher: "",
      },
      setScoreData: {
        testId: "",
        source: 0,
        score: "",
        testName: "",
      },
      paperApplyListSimple: [],
      paperApplyListProfessional: [],
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        paperGroupName: "",
        reviewStatus: "",
        createTime: "",
        userName: "",
        paperName: "",
        testName: "",
        ids: [],
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          key: "choose",
        },
        {
          title: "考试名称",
          key: "testName",
        },

        {
          title: "论文分组",
          key: "paperGroupName",
        },
        {
          title: "论文名称",
          key: "paperName",
        },
        {
          title: "考生姓名",
          key: "userName",
        },
        {
          title: "评分人",
          key: "submitNum",
        },
        {
          title: "分数",
          key: "scoreString",
        },
        {
          title: "最终成绩",
          key: "score",
        },
        {
          title: "状态",
          key: "interviewResult",
        },
        {
          title: "答辩时间",
          key: "reverseTime",
        },
        {
          title: "操作",
          slot: "action",
          width: 190,
          align: "center",
        },
      ],
      paperInterviewList: [],
      reviewOptions: [
        {
          value: 0,
          label: "通过",
        },
        {
          value: 1,
          label: "未通过",
        },
        {
          value: 2,
          label: "未开始",
        },
      ],
    };
  },
  computed: {
    paperApplyListComputed() {
      return [this.paperApplyListProfessional, this.paperApplyListSimple][
        this.setScoreData.source
      ];
    },
  },
  created() {},
  mounted() {
    this.getPaperInterviewList();
    this.getPaperApplyList();
  },
  methods: {
    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getPaperInterviewList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getPaperInterviewList();
    },
    getPaperInterviewList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getPaperInterviewList(this.searchCondition).then((data) => {
        console.log("paperSettingList结果", data);
        this.paperInterviewList = data.records;
        this.paginations.total = data.total;
      });
    },
    goToDetail(routerName, item) {
      this.$router.push({ name: routerName, query: { id: item.id } });
    },
    clearTestId() {
      console.log("清除testId进来了");
      this.setScoreData.testId = null;
    },
    getPaperApplyList() {
      getPaperApplyList({ source: 0 }).then((data) => {
        console.log("paperApplyListPro结果", data);
        this.paperApplyListProfessional = data;
      });
      getPaperApplyList({ source: 1 }).then((data) => {
        console.log("paperApplyListSimple结果", data);
        this.paperApplyListSimple = data;
      });
    },
    setPassScore() {
      setPassScore(this.setScoreData).then((data) => {
        console.log("提交返回的data", data);
        this.$message.success("保存成功");
      });
      this.setScore = false;
    },
    input(e) {
      e = e.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      this.markData.score = e;
    },

    exportData() {
      let idList = this.searchCondition.ids.reduce((total, item) => {
        total.push(item.id);
        return total;
      }, []);
      this.searchCondition.ids = idList;
      console.log("aaaaaa", this.searchCondition.ids);
      console.log("jiiiiiiiiiiiiiiiii");
      exportPaperInterviewList(this.searchCondition)
        .then((data) => {
          console.log("来咯", data);
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "面试列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    uploadPaper(e) {
      console.log("aaaaaa");
      let formData = new FormData();
      formData.append("file", e.file);
      console.log("jiiiiiiiiiiiiiiiii");
      importPaperInterviewList(formData)
        .then((data) => {
          console.log("来咯", data);
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "面试导入失败列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    importData() {
      if (this.$refs.upload) {
        this.$refs.upload.submit();
        this.dialogVisibleImport = false;
      } else {
        console.error("未找到upload控件");
      }
    },

    //重置 upload文件
    reset() {
      this.$refs.upload = null;
    },

    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.error({
        title: "错误",
        message: "只能上传一个文件哦",
      });
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      console.log("file00000", file);
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        this.fileList = [];
        this.file = "";
        return false;
      }
      this.file = file.raw;
      this.filename = file.name;
    },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      console.log("before upload");
      console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.$notify.warning({
          title: "警告",
          message: `只能上传后缀是(.xlsx或者.xls）的文件`,
        });
      }
      if (size > 10) {
        this.$notify.warning({
          title: "警告",
          message: `文件大小不得超过10M`,
        });
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      let blob = new Blob([JSON.stringify(res)], { type: "application/json" });
      // console.log('blob', blob)
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "change_" + file.name;
      a.click();
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`,
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  font-size: 12px;
  margin: 15px;

  .searchBar {
    background: #fff;
    margin-bottom: 15px;
    padding: 20px;

    .searchInput {
      width: 20%;
    }

    .saveBar {
      display: inline-block;
      float: right;
    }
  }

  .tableContainer {
    background: #fff;
    padding: 20px;

    .actionBar {
      padding-bottom: 10px;

      .setScoreBar {
        float: right;
      }
    }

    .bluBar {
      width: auto;
      color: #36aafd;
      border: 1px solid #36aafd;
      padding: 7px 10px;
      border-radius: 4px !important;
    }
  }
}
</style>
